import {flow, makeObservable, observable} from "mobx";
import {EAIClient} from "../../services/EAIClient";
import {appStore} from "..";


export type ViewerUserNotificacion = {
    user_ruuid: number;
    user: {first_name: string, last_name: string};
    role: string;
    enabled: boolean;
    is_current_user: boolean;
}


class NotificationViewerStore {
 @observable totalCount: number;
 @observable viewersNotifications: ViewerUserNotificacion[] = [];
 @observable isProcessing = false;
 @observable pageIndex = 0;

 client = new EAIClient();

 constructor(){
    makeObservable(this);
 }

 @flow
 *fetchUserViewersNotification (action_plan: string): any {
    this.isProcessing = false;
    try {
        this.isProcessing = true;
        const viewers_response = yield this.client.getViewersNotificacion(action_plan);
        this.viewersNotifications = viewers_response.data.data as ViewerUserNotificacion[];
        this.isProcessing = false;
        return this.viewersNotifications;
    } catch (error) {
        appStore.addError(error);
        this.isProcessing = false;

    } finally{
        this.isProcessing = false;
    }
 }

 @flow
 *enableNotificaciones (actionplan_ruuid: string, user_id: string): any{
    this.isProcessing = false;
    try {
        this.isProcessing = true;
        yield this.client.enableNotificacions(actionplan_ruuid, user_id, true);
    } catch (error) {
        this.isProcessing = false;
        appStore.addError(error);
    } finally{
        this.isProcessing = false;
    }
 }

 @flow
 *deactivateNotificaciones (actionplan_ruuid: string, user_id: string): any{
    this.isProcessing = false;
    try {
        this.isProcessing = true;
        yield this.client.enableNotificacions(actionplan_ruuid, user_id, false);
    } catch (error) {
        this.isProcessing = false;
        appStore.addError(error);
    } finally{
        this.isProcessing = false;
    }
 }
 @flow
 *setPageIndex(page: number){
    this.pageIndex = page;
 }
}

export {NotificationViewerStore};